import React from 'react';

export default function CalloutBanner(props) {
  const { calloutBanners } = props;
  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const chunks = chunkArray(calloutBanners, 2);

  return (
    <>
      {chunks.map((chunk, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="flex-column-top mr-1 pt-1" key={index}>
          {chunk.map((tag, tagIndex) => (
            <div className={`row ${tagIndex === 0 ? 'mb-1' : ''}`} key={tag.name}>
              <span
                className="tag lox-banner-tags lox-no-border has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary is-warning has-text-white lox-banner-orange no-radius"
                data-tooltip={tag.description}
              >
                {tag.name}
              </span>
            </div>
          ))}
        </div>
      ))}
    </>
  );
}
